// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1HfQx","label":"Completed_label__32Bek"};